
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DcService } from '../services/dc.service';

@Injectable()
export class DcResolver implements Resolve<any> {
    constructor(private dcService: DcService) { }
    public resolve(route: ActivatedRouteSnapshot) {
        const params = route.params;
        return this.dcService.findOne(params['partnerDcId']);
    }
}
